import { ampli } from "services/ampli";
import { loadAmpli } from "services/attributionConfig";

export const handleAmpliLoaded = async (callback: () => void) => {
    if (!ampli.isLoaded) {
        await loadAmpli();
    }
    callback();
};
